import { render, staticRenderFns } from "./NotifyFormConfirm.vue?vue&type=template&id=5f3a275c&scoped=true&"
import script from "./NotifyFormConfirm.vue?vue&type=script&lang=js&"
export * from "./NotifyFormConfirm.vue?vue&type=script&lang=js&"
import style0 from "./NotifyFormConfirm.vue?vue&type=style&index=0&id=5f3a275c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3a275c",
  null
  
)

export default component.exports